import { setCallListId } from './query';
import { getCallList } from './search';

export const CHANGE_TASKS_VIEW = 'CHANGE_TASKS_VIEW';
export function changeTasksView(view) {
  return { type: CHANGE_TASKS_VIEW, view: view };
}

export const ADD_CALL_LIST = 'ADD_CALL_LIST';
export const addCallList = callList => (
  (dispatch) => {
    dispatch({ type: ADD_CALL_LIST, callList: callList });
    dispatch(setCallListId(callList.id));
    dispatch(getCallList());
  }
);

export const REMOVE_CALL_LIST = 'REMOVE_CALL_LIST';
export function removeCallList(callListId) {
  return { type: REMOVE_CALL_LIST, callListId: callListId };
}

export const UPDATE_CALL_LIST = 'UPDATE_CALL_LIST';
export function updateCallList(callList) {
  return { type: UPDATE_CALL_LIST, callList: callList };
}

export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export function toggleAlert(message, error) {
  return { message, error, type: TOGGLE_ALERT };
}

export const UPDATE_PREVIEW_DATA = 'UPDATE_PREVIEW_DATA';
export function updatePreviewData(personId, personType, taskId = null) {
  return { personId, personType, taskId, type: UPDATE_PREVIEW_DATA };
}

export function handleRemoveCallList(callListId) {
  return (dispatch, getState) => {
    const callLists = Object.values(getState().ui.callLists).reverse();
    const callList = callLists.find(cl => cl.id != callListId);

    dispatch(removeCallList(callListId));

    if (callList) {
      dispatch(setCallListId(callList.id));
      dispatch(getCallList());
    }
  };
}